export const estadisticasResumenService = {
    async getEstadisticasResumen(token = null, fechaDesde = null, fechaHasta = null, proyectoId = null) {
        try {
            // Obtener token del localStorage si no se proporciona
            const authToken = token || localStorage.getItem('token');

            if (!authToken) {
                throw new Error('No hay token de autenticación');
            }

            // Construir la URL con parámetros
            const params = new URLSearchParams();
            if (fechaDesde) params.append('fdesde', fechaDesde);
            if (fechaHasta) params.append('fhasta', fechaHasta);
            if (proyectoId) params.append('proyectoId', proyectoId);

            const queryStr = params.toString();
            const url = `/api/dashboard/resumen${queryStr ? '?' + queryStr : ''}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Token de autenticación inválido o expirado');
                }
                throw new Error(`Error HTTP: ${response.status}`);
            }

            const data = await response.json();
            console.log('🎯 [Estadísticas Resumen] Respuesta de la API:', data);

            // Extraer los datos del response
            return data;
        } catch (error) {
            console.error('[Estadísticas Resumen] Error:', error);
            throw error;
        }
    }
};
